import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import dayjs from '@ucheba/utils/helpers/date/dayjs'

interface InstitutionLicensesProps {
  license: number | null
  dateLicense: Record<string, unknown> | null
  accreditation: string | null
  dateAccreditation: Record<string, unknown> | null
}

const InstitutionLicenses: FC<InstitutionLicensesProps> = ({
  license,
  dateLicense,
  accreditation,
  dateAccreditation,
}) => (
  <>
    <Heading h2='Лицензии и официальные документы' spacing='small' />

    <Grid>
      {(license || dateLicense) && (
        <GridCol uxs={12}>
          {license && (
            <>
              <Heading h4='Лицензия' spacing='xxsmall' />

              <Text fontWeight='semibold' as='span'>
                {license}
              </Text>
            </>
          )}

          {dateLicense && (
            <>
              <Text as='span' color='gray50'>
                {' от '}
              </Text>

              <Text fontWeight='semibold' as='span'>
                {dayjs(dateLicense).format('DD.MM.YYYY')}
              </Text>
            </>
          )}
        </GridCol>
      )}

      {(accreditation || dateAccreditation) && (
        <GridCol uxs={12}>
          {accreditation && (
            <>
              <Heading h4='Аккредитация' spacing='xxsmall' />

              <Text fontWeight='semibold' as='span'>
                {accreditation}
              </Text>
            </>
          )}

          {dateAccreditation && (
            <>
              <Text as='span' color='gray50'>
                {' от '}
              </Text>

              <Text fontWeight='semibold' as='span'>
                {dayjs(dateAccreditation).format('DD.MM.YYYY')}
              </Text>
            </>
          )}
        </GridCol>
      )}
    </Grid>
  </>
)

export default memo(InstitutionLicenses)
